export default __webpack_public_path__ + "static/media/foundation-nft-logo.058556b9.svg";